/**
 * 
 * @project davich admin
 * @author mrwang 2022.03.07
 * 
 */

import axios from 'axios'
import dotenv from 'dotenv';
import { router } from '../router/index';
import store from '../store/index';
import VueSimpleAlert from "vue-simple-alert";


dotenv.config();

const apiServerUrl = process.env.VUE_APP_API_SERVER_URL;

// console.log('apiServerUrl => ', apiServerUrl) ; 

// const apiServerUrl = "http://116.126.85.64:8222/api/v1";
// const apiServerUrl = "http://14.63.225.142:8222/api/v1";     // test 
// const apiServerUrl = "http://116.126.85.64/api/v1";          // live 

const instance = axios.create({
    baseURL: apiServerUrl,
    headers: { 'Accept-Language': 'ko'}
});

// 401 응답이어도 로그인 페이지로 보내지 않는 인증 관련 요청
const AUTH_URLS = ['/auth/admin/login', '/auth/admin/accesstoken', '/auth/authnumberemail', '/auth/authnumberemail/check'];

// API 의 isAuthenticated 가 access_token 만료 시 내려주는 error_code
const ERROR_CODE_TOKEN_EXPIRED = 40103;

// 동시에 여러 요청이 만료되어도 갱신 요청은 한 번만 보낸다.
let refreshPromise = null;
// 로그인 페이지 이동 알림이 여러 번 뜨지 않도록 막는다.
let isMovingToLogin = false;

function getStoredToken(key) {
    const token = localStorage.getItem(key);
    // 로그아웃 시 null 이 문자열 "null" 로 저장되므로 함께 걸러낸다.
    if (!token || token === 'null' || token === 'undefined') {
        return null;
    }
    return token;
}

// access_token 갱신 ( PUT /auth/admin/accesstoken )
// 인터셉터를 타지 않도록 기본 axios 로 요청한다.
function refreshAccessToken() {
    if (!refreshPromise) {
        refreshPromise = axios.put(`${apiServerUrl}/auth/admin/accesstoken`, {
            access_token: getStoredToken('accessToken'),
            refresh_token: getStoredToken('refreshToken'),
        }).then((res) => {
            store.commit('auth/SET_ACCESS_TOKEN', { accessToken: res.data.access_token });
            if (res.data.refresh_token) {
                store.commit('auth/SET_REFRESH_TOKEN', { refreshToken: res.data.refresh_token });
            }
            return res.data.access_token;
        }).finally(() => {
            refreshPromise = null;
        });
    }
    return refreshPromise;
}

// 저장된 로그인 정보를 지우고 로그인 페이지로 이동
function logoutAndMoveToLogin() {
    if (isMovingToLogin) {
        return;
    }
    isMovingToLogin = true;

    store.dispatch('auth/reqLogout').then(() => {
        VueSimpleAlert.fire({
            title: '로그인이 만료되었습니다.',
            text: "로그인 페이지로 이동합니다." ,
            type: "error",
            timer: 5000
        }).then(() => {
            isMovingToLogin = false;
            router.push({ name: "Login" });
        });
    });
}

// before a request is made start
instance.interceptors.request.use(function (config) {


    const token = getStoredToken('accessToken');
    const lang  = localStorage.getItem('LANGUAGE');
    if (token) {
        // 재요청 시 이전 토큰이 남지 않도록 common 이 아닌 요청 헤더에 직접 넣는다.
        config.headers['Authorization'] = `Bearer ${token}`;
        config.headers.common['Content-Type'] = 'application/json;charset=UTF-8';
    }
    config.headers['Accept-Language'] = lang;

    return config
    }, function (error) {
        // Do something with response error
        return Promise.reject(error.response)
    }
);


// before a response is returned stop  
instance.interceptors.response.use(
    (response) => {

        return response;
    },
    (error) => {
        const config = error.config;
        if ( error.response && error.response.status === 401 && config && !AUTH_URLS.includes(config.url) ) {
            console.log('error ==> ', error.response.status );
            console.log('error ==> ', error.response );
            console.log('error ==> ', config.url  );

            // 화면에서 실패 알림을 중복으로 띄우지 않도록 표시
            error.isAuthError = true;

            // access_token 만료 → refresh_token 으로 갱신 후 원래 요청을 한 번 재시도
            const data = error.response.data || {};
            if ( data.error_code === ERROR_CODE_TOKEN_EXPIRED && !config._retry && getStoredToken('refreshToken') ) {
                config._retry = true;
                return refreshAccessToken().then((newToken) => {
                    config.headers['Authorization'] = `Bearer ${newToken}`;
                    return instance(config);
                }).catch((refreshError) => {
                    console.log('refresh access token fail => ', refreshError);
                    logoutAndMoveToLogin();
                    return Promise.reject(error);
                });
            }

            logoutAndMoveToLogin();
        }
        return Promise.reject(error);

    }
);
  
 
export default instance
